// extracted by mini-css-extract-plugin
module.exports = {"root":"Photo_root__1jl3m","photo":"Photo_photo__1oxXc","header":"Photo_header__2zE1F","footer":"Photo_footer__1lM7d"};